import PsikotestParticipantLayout from "./PsikotestParticipantLayout";

function PsikotestParticipantApp() {
  return <PsikotestParticipantLayout />;
}

export default PsikotestParticipantApp;
